export interface ZipCodeData {
  street?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
  error?: boolean;
}

export async function fetchZipCode(
  zipCode: string,
): Promise<ZipCodeData | null> {
  const cleanZip = zipCode.replace(/\D/g, '');
  if (cleanZip.length !== 8) return null;

  try {
    const response = await fetch(`https://viacep.com.br/ws/${cleanZip}/json/`);
    const data = await response.json();
    return {
      street: data.logradouro,
      neighborhood: data.bairro,
      city: data.localidade,
      state: data.uf,
      error: data.erro,
    };
  } catch {
    return null;
  }
}
